import { FC } from 'react';

import { SignUpForm } from './SignUpForm';
import {
    Card,
    CardDescription,
    CardHeader,
    CardTitle,
} from '../../components/ui/Card';

const SignUp: FC = () => (
    <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[400px]">
        <Card>
            <CardHeader className="space-y-1">
                <CardTitle className="text-center text-2xl">
                    Створити обліковий запис
                </CardTitle>
                <CardDescription className="text-center">
                    Введіть вашу інформацію для створення облікового запису
                    CartOn
                </CardDescription>
            </CardHeader>

            <SignUpForm />
        </Card>
    </div>
);

export default SignUp;
